import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
library.add(faPhoneAlt)